import { defineMessages } from 'react-intl';

export const contextMentionListMessages = defineMessages({
  noMatches: { defaultMessage: 'No matches', id: '96GJ5wSQam' },
  templates: { defaultMessage: 'Templates', id: 'A3ptulOTB3' },
  skillFile: { defaultMessage: 'Skill file', id: 'yKx3EoNw7q' },
  upload: {
    defaultMessage: 'Upload',
    id: 'z/FkCzeO6O',
    description: 'Composer mention subtitle for an uploaded Library document',
  },
  heidiOutput: { defaultMessage: 'Heidi output', id: 'V/3w48ikt1' },
  formTemplate: { defaultMessage: 'Form template', id: 'ju+1DBLfRk' },
  objectsLabel: {
    defaultMessage: 'Mention an object',
    id: 'oPn1j/Qk26',
    description: 'Accessible label for the Work composer object mention picker',
  },
  patients: { defaultMessage: 'Patients', id: '1eiSDTlf+P' },
  sessions: { defaultMessage: 'Sessions', id: 'Z3EDd9nO/N' },
  documents: { defaultMessage: 'Documents', id: 'vBlT6yzK/6' },
  tasks: {
    defaultMessage: 'Tasks',
    id: 'deoznUxWBi',
    description:
      'Section heading for open clinical tasks in the Work composer object mention picker',
  },
  collections: {
    defaultMessage: 'Collections',
    id: 'TWevgJB5N+',
    description:
      'Section heading for library collections in the Work composer object mention picker',
  },
  taskOverdue: {
    defaultMessage: 'Overdue',
    id: 'b6/oZHLqbC',
    description:
      'Due-date label for an overdue task in the Work composer object mention picker',
  },
  taskDueToday: {
    defaultMessage: 'Today',
    id: '+M1h8WQvrO',
    description:
      'Due-date label for a task due today in the Work composer object mention picker',
  },
  collectionDocumentCount: {
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
    id: 'W1tfoAtkPM',
    description:
      'Document count for a library collection in the Work composer object mention picker',
  },
});

export const libraryDocumentKindMessages = {
  artifact: contextMentionListMessages.heidiOutput,
  workflow_context: contextMentionListMessages.skillFile,
  input: contextMentionListMessages.upload,
} as const;
